module.exports = __webpack_public_path__ + "4e8a31bd8a178b3b93fb7a9b6e3cffc7.pdf";